// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#all-approval-pending-cases .stickyNavbar {\n  padding-bottom: 5px !important;\n}\n#all-approval-pending-cases .stickyNavbar .container-default {\n  padding-top: 0;\n}", ""]);
// Exports
module.exports = exports;
